"use strict";
var zip_1 = require('../operators/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/observable/zip.js